module.exports = __webpack_public_path__ + "media/images/v2/b_1-a2598d7e4d809c096a9dae7983d4246d.png";